export default __webpack_public_path__ + "static/media/lucy.42757e27.png";